import { ReactComponent as CSV } from "@/assets/svgs/csv.svg";
import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as Delete } from "@/assets/svgs/delete.svg";
import { ReactComponent as DownloadEclip } from "@/assets/svgs/download-eclip.svg";
import { ReactComponent as EForm } from "@/assets/svgs/eform.svg";
import { ReactComponent as Eye } from "@/assets/svgs/eye.svg";
import { ReactComponent as IconMenu } from "@/assets/svgs/menu-dark.svg";
import { ReactComponent as TradeTrust } from "@/assets/svgs/trade-trust.svg";
import Dropdown from "@/components/Dropdown3/index";
import MenuDropDown from "@/components/MenuDropDown";
import { ToastContext } from "@/context/toast/index.js";
import useEclips from "@/hooks/use-eclips/index.js";
import useModal from "@/hooks/use-modal/index";
import { useParams } from '@/lib/router-dom/index';
import api from "@/services/api/files.js";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MultiClamp from 'react-multi-clamp';
import AttachmentsViewModal from "./attachments-view-modal.jsx";
import ConfirmDeleteModal from "./confirm-delete-modal.jsx";
import DownloadDataModal from "./download-data-modal.jsx";
import ReceivingDataElementCard from "./receiving-data-element-card.jsx";
import VerifiedByModal from "./verified-by-modal.jsx";
import { generateFileURLFromBase64 } from "@/utils/download";
import fileExtensions, { extensionList } from "@/constants/file-extensions";
import StatusTags, { STATUS } from '@/componentsDS/Tags/StatusTags';

export function ProvideOnBehalf() {
	return <div className="eclip-data-elements__list-item-on-behalf-title">
		{"Provide On Behalf Of"}
		<span className="eclip-data-element-onbehalf-required">
			*
		</span>
	</div>;
}

export const HandlePreviewAttachment = async (file_content, addToastMessage) => {

	/**
	 * We're getting fileName from file_content property.
	 * If it is not there then we're considering key property.
	 * If it doesn't match anyone property then we're checking with file_content object itself
	 *
	 * Key name varies from two modules: my packages and shared with me.
	 * */
	const fileID = file_content?.file_content ?? file_content?.key ?? file_content;
	try {
		/* Fetching file data */
		const res = await api.findOne(fileID);

		/* Generate fileURL from the base64 value */
		const fileURL = generateFileURLFromBase64(
			res.data.data,
			'application/pdf;base64',
		);

		/* Opening the generated file URL */
		window.open(fileURL);
	} catch(err) {
		console.error({err, message: "Unable to preview attachment!"});
		addToastMessage(
			err?.response?.data?.error?.message ||
			"File Preview Failed",
			"error"
		);
	}
};

export function SelectedContributorUI(selectedContributor) {
	const contributor = selectedContributor ? selectedContributor[0]?.name : "";
	return <div className="eclip-data-elements__structured-data__attachment eclip-data-elements_list-item tooltip">
		<span className="filename">
			{contributor}
		</span>
		<span className="tooltiptext">
			{contributor}
		</span>
	</div>;
}

export function FileUploadHandleDataFunction(handleDataUpload, dataElementId, type) {
	return <input
		type="file"
		className="hidden"
		data-testid={`input-structured-${dataElementId}`}
		onChange={(e) => {
			handleDataUpload(
				e.target.files?.[0],
				dataElementId,
				type
			);
		}}
		accept=".csv"
		id={`structured-${dataElementId}`}
	></input>;
}

export function DisplayFunctionForLists(handleImportData, dataElementId, type, source, showClearConfirmModal, isCustom, eclipType, showConfirmModal) {
	return [
		{
			label: "Import Data",
			onClick: (e) => {
				e.stopPropagation();
				handleImportData(
					dataElementId,
					type
				);
			},
		},
		source === "IMPORTED"
			? {
				label: "Clear Import Data",
				color: "#A72E12",
				onClick: (e) => {
					e.stopPropagation();
					showClearConfirmModal();
				},
			}
			: undefined,
		isCustom &&
			eclipType === 'SEND'
			? {
				label: "Remove Data Element",
				color: "#A72E12",
				onClick: async (e) => {
					e.stopPropagation();
					showConfirmModal();
				},
			}
			: undefined,
	];
}

export function HandleAddAttachmentFunction(handleAddAttachment, dataElementId) {
	return <div
		className="eclip-data-elements__add-attachment eclip-data-elements_list-item"
		data-testid={`add-attachment-${dataElementId}`}
		onClick={() => {
			handleAddAttachment(`attachment-${dataElementId}`);
		}}
	>
		{"Add Attachment +"}
	</div>;
}

export function HandleFileUploadFunction(handleFileUpload, dataElementId, type) {
	const { addToastMessage } = useContext(ToastContext);

	return <input
		type="file"
		className="hidden"
		accept={fileExtensions.type}
		data-testid={`input-attachment-${dataElementId}`}
		onChange={(e) => {
			const file = e.target.files?.[0];
			if (!file) return;

			// Validate file extension
			const fileName = file.name;
			const fileExt = fileName.substring(fileName.lastIndexOf('.'));
			if (!extensionList.includes(fileExt)) {
				addToastMessage(fileExtensions.errorMessage, "error");
				e.target.value = "";
				return;
			}

			handleFileUpload(file, dataElementId, type);
		}}
		id={`attachment-${dataElementId}`}
	></input>;
}

export function DropdownSelection(provideItemsLists, setContributor, dataElementId, selectedContributor) {
	const contributor = selectedContributor ? selectedContributor[0] : null;
	return <div className="eclip_filter__col__top overview_filter__col__bottom--background overview_filter__col__width eclip_filter__col__top-position">
		<Dropdown
			full
			text={"Select Contributor"}
			options={provideItemsLists}
			submit={(data) => {
				setContributor(dataElementId, data, true);
			}}
			disabled={provideItemsLists.length === 1}
			value={contributor} />
	</div>;
}

export function HandleAddStructuredFunction(handleAddAttachment, dataElementId) {
	return <div
		id="handle-add-attachment"
		className="eclip-data-elements__structured-data__via"
		data-testid={`add-structured-${dataElementId}`}
		onClick={() => {
			handleAddAttachment(
				`structured-${dataElementId}`
			);
		}}
	>
		via CSV &nbsp;
		<CSV />
	</div>;
}

export function HandleAddViewFormFunction(handleAddViaForm, dataElementId, type) {
	return <div className="eclip-data-elements__structured-data__via"
		onClick={() => {
			handleAddViaForm(dataElementId, type);
		}}>
		via E-form &nbsp;
		<EForm />
	</div>;
}

export function DisplayStructuredData(required) {
	return <div className="eclip-data-elements__list-item-group-title">
		<span>{"Structured Data"}&nbsp;{required && <span className="eclip-data-element-attachment-required">*</span>}</span>
	</div>;
}

export function DisplayBackGroundImage(isPayloadAdded) {
	return <div className={"eclip-data-elements__list-icon" + (isPayloadAdded ? " active" : "")}
		style={{
			backgroundImage: `url(${assetUrl('/svgs/data-element.svg')})`,
		}}></div>;
}

export function HandleTradeTrustLogoFunction(showVerifiedByModal) {
	return <div className="eclip-data-elements__list-item-header--trade-trust">
		<span className="icon">
			<TradeTrust />
		</span>
		<span
			onClick={showVerifiedByModal}
			className="text transaction--underline"
		>
			Verified
		</span>
	</div>;
}

export function HandlePayloadViewFunction(isEditable, elementName, isDeclined) {
	return <ReceivingDataElementCard
		message="No Payloads or Attachments sent"
		isEditable={isEditable}
		elementName={elementName}
		isDeclined={isDeclined} />;
}

export function HandledDeleteFunction(handleStructuredDataRemove, dataElementId, type) {
	return <span className="eclip-data-elements__attachment_link">
		<Delete
			data-testid={`delete-structured-${dataElementId}`}
			onClick={() => {
				handleStructuredDataRemove(
					dataElementId,
					type
				);
			}} />
	</span>;
}

export function DisplayAddEyeFunction(handleAddViaForm, dataElementId, type) {
	return <span
		className="eclip-data-elements__attachment_link"
		onClick={() => {
			handleAddViaForm(dataElementId, type);
		}}
	>
		<Eye fill="#A614B9" />
	</span>;
}

export function HandleDeleteRemoveAttachment(handleRemoveAttachment, dataElementId, type, index) {
	return <span className="eclip-data-elements__attachment_link">
		<Delete
			data-testid={`delete-attachment-${dataElementId}-${index}`}
			onClick={() => {
				handleRemoveAttachment(
					dataElementId,
					type,
					index
				);
			}} />
	</span>;
}

export function HandlePreviewEyeFunction(attachment, addToastMessage) {
	return <span
		data-testid={"download-button"}
		className="eclip-data-elements__attachment_link"
		onClick={() => {
			HandlePreviewAttachment(attachment, addToastMessage);
		}}
	>
		<Eye fill="#A614B9" />
	</span>;
}

export default function SendingDataElementCard({
	eclipType,
	dataElementId,
	elementName,
	elementSchema,
	messageStoreId,
	payload = {},
	type,
	isCustom,
	required,
	source,
	sourceFilename,
	verificationStatus,
	isTTFlow,
	issuerDetail,
	modified,
	isDownloadable,
	isDeclined,
	isEditable,
	isNew,
	isDraft,
	hasExpired,
	handleStructuredDataRemove,
	handleDataUpload,
	handleAddViaForm,
	handleAddAttachment,
	handleFileUpload,
	handleRemoveAttachment,
	handleImportData,
	handleUpdateIsNew,
	reload,
	sent,
	setContributor,
	isOnBehalfOf,
	provideItemsLists,
	selectedContributor,
	currentPackage
}) {
	// const params = useParams();
	const { eclipId } = useParams();
	const { addToastMessage } = useContext(ToastContext);
	const { t } = useTranslation();

	const { addRemoveDataElements, clearImportData } = useEclips();

	const { visible: isDownloadModalVisible, hide: hideDownloadModal, show: showDownloadModal } = useModal();
	const { visible: confirmModalVisible, hide: hideConfirmModal, show: showConfirmModal } = useModal();
	const { visible: confirmClearModalVisible, hide: hideClearConfirmModal, show: showClearConfirmModal } = useModal();
	const { visible: verifiedByModalVisible, hide: hideVerifiedByModal, show: showVerifiedByModal } = useModal();

	const [viewAll, setViewAll] = useState(false);
	const attachments = payload?.attachments || [];

	const [isNewFlag, setIsNewFlag] = useState(false)

	useEffect(() => {
		if (isNew) setIsNewFlag(isNew)
	}, [isNew])

	let isPayloadAdded = sourceFilename?.length > 0 || Object.keys(payload || {})?.filter((key) => key !== "attachments").length > 0;

	const isAttachmentsAdded = !isDeclined || attachments.length > 0;
	const isPayloadViewable = !isDeclined || isPayloadAdded;

	if (!isPayloadViewable && !isAttachmentsAdded) {
		return HandlePayloadViewFunction(isEditable, elementName, isDeclined);
	}

	const handleClearImportData = async () => {
		await clearImportData(eclipId, dataElementId);
		reload();
	};

	const isNotImported = source !== "IMPORTED";

	const validateNew = (isNewFlag && isCustom && (eclipType === "RECEIVE" || type === "RECEIVER_SEND"))

	function handleNew() {
		if (validateNew) {
			handleUpdateIsNew(dataElementId, isNew, type, eclipType)
				.then(() => {
					return setIsNewFlag(false)
				})
				.catch(() => {
					return
				})
		}
	}

	return (
		<div onClick={() => handleNew()} data-testid="id" className={"eclip-data-elements__list-item" + (isDeclined ? " declined" : "")}>
			<div className="eclip-data-elements__list-item-header">
				{DisplayBackGroundImage(isPayloadAdded)}
				{verificationStatus === "VERIFIED" && isDownloadable && (
					HandleTradeTrustLogoFunction(showVerifiedByModal)
				)}
				{isTTFlow && (
					HandleTradeTrustLogoFunction(showVerifiedByModal)
				)}
				{hasExpired && (
					<>&nbsp; <StatusTags status={STATUS.EXPIRED} /></>
				)}
				<VerifiedByModal
					visible={verifiedByModalVisible}
					close={hideVerifiedByModal}
					date={moment(modified).format("lll")}
					issuerName={issuerDetail?.[0]?.name}
					elementName={elementName}
				/>
				<div className="eclip-data-element__side-header">
					<div className="eclip-data-element__side-header">
						{validateNew && (
							<div className="eclip-data-element__new-tag">New</div>
						)}
						{!hasExpired && isDownloadable ? (
							<>
								<div className="eclip-data-elements__list-item-header--download" onClick={showDownloadModal}>
									<DownloadEclip />
								</div>

								<DownloadDataModal
									visible={isDownloadModalVisible}
									close={hideDownloadModal}
									messageStoreId={[messageStoreId]}
									dataElementId={dataElementId}
									packageName={currentPackage?.name}
								/>
							</>
						) : (
							isEditable && (
								<>
									<MenuDropDown
										button={(props) => (
											<span
												className="eclip-landing_cursor-mode__pointer cursor-lg-area"
												{...props}
											>
												<IconMenu />
											</span>
										)}
										list={DisplayFunctionForLists(handleImportData, dataElementId, type, source, showClearConfirmModal, isCustom, eclipType, showConfirmModal)}
									/>
									<DownloadDataModal
										visible={isDownloadModalVisible}
										close={hideDownloadModal}
										messageStoreId={[messageStoreId]}
										dataElementId={dataElementId}
										packageName={currentPackage?.name}
									/>
								</>
							)
						)}
					</div>
				</div>
			</div>
			<div className="eclip-data-elements__list-item-title">
				<MultiClamp clamp={1}>{elementName}</MultiClamp>
			</div>
			{elementSchema &&
				(isPayloadAdded ? (
					<>
						{isOnBehalfOf && eclipType === "SEND" && (
							<>
								<ProvideOnBehalf />
								{(sent && !isDraft) && (
									SelectedContributorUI(selectedContributor)
								)}
								{(!sent || (sent && isDraft)) && (
									DropdownSelection(provideItemsLists, setContributor, dataElementId, selectedContributor)
								)}
							</>
						)}
						{isOnBehalfOf && eclipType === "RECEIVE" && (
							<>
								<ProvideOnBehalf />
								{SelectedContributorUI(selectedContributor)}
							</>
						)}
						{DisplayStructuredData(required)}
						<div className="eclip-data-elements__structured-data">
							{sourceFilename?.length > 0 ? (
								<div className="eclip-data-elements__structured-data__attachment eclip-data-elements_list-item tooltip">
									<span className="filename" data-testid={`structured-${dataElementId}-filename`}>
										{sourceFilename}
									</span>
									<span className="tooltiptext">
										{sourceFilename}
									</span>
									{!hasExpired && <span className="eclip-data-elements__structured-data__attachment__action">
										{DisplayAddEyeFunction(handleAddViaForm, dataElementId, type)}
										{!isDeclined && isNotImported && ((eclipType === "RECEIVE" && isEditable) || (eclipType === "SEND" && (!sent || isEditable))) && (
											HandledDeleteFunction(handleStructuredDataRemove, dataElementId, type)
										)}
									</span>}
								</div>
							) : (
								<div className="eclip-data-elements__structured-data__attachment eclip-data-elements_list-item">
									<span>Filled via E-form</span>
									{!hasExpired && <span className="eclip-data-elements__structured-data__attachment__action">
										{DisplayAddEyeFunction(handleAddViaForm, dataElementId, type)}
										{!isDeclined && isNotImported && ((eclipType === "RECEIVE" && isEditable) || (eclipType === "SEND" && (!sent || isEditable))) && (
											HandledDeleteFunction(handleStructuredDataRemove, dataElementId, type)
										)}
									</span>}
								</div>
							)}
						</div>
					</>
				) : (
					<>
						{!isDeclined && (
							FileUploadHandleDataFunction(handleDataUpload, dataElementId, type)
						)}
						{isOnBehalfOf && eclipType === "SEND" && (
							<>
								<ProvideOnBehalf />
								{DropdownSelection(provideItemsLists, setContributor, dataElementId, selectedContributor)}
							</>
						)}
						{isPayloadViewable && (
							DisplayStructuredData(required)
						)}
						<div className="eclip-data-elements__structured-data">
							{!isDeclined && (
								HandleAddViewFormFunction(handleAddViaForm, dataElementId, type)
							)}
							{!isDeclined && (
								HandleAddStructuredFunction(handleAddAttachment, dataElementId)
							)}
						</div>
					</>
				))
			}
			<div className="eclip-data-elements__list-item-group-title">
				{isAttachmentsAdded && (
					<span>
						{t("attachments")} ({attachments.length}){" "}
						{elementSchema && "required" in elementSchema &&
							elementSchema.required.includes("attachments") && (
								<span className="eclip-data-element-attachment-required">
									*
								</span>
							)
						}
					</span>
				)}
				<AttachmentsViewModal
					data={attachments}
					dataElementId={dataElementId}
					visible={viewAll}
					type={type}
					handleRemoveAttachment={handleRemoveAttachment}
					isEditable={isEditable}
					close={() => setViewAll(false)}
					hasExpired={hasExpired}
				/>
				{attachments.length > 2 && (
					<>
						<span
							className="eclip-data-elements__list-item-group-title__action"
							onClick={() => {
								setViewAll(!viewAll);
							}}
						>
							View All
						</span>
					</>
				)}
			</div>
			{[...attachments]
				.splice(0, 2)
				?.filter((attachment) => attachment.filename)
				?.map((attachment, index) => (
					<div
						className="eclip-data-elements__attachment eclip-data-elements_list-item tooltip"
						data-testid={`attachment-${dataElementId}-${index}`}
						key={`att-${index}`}
					>
						<span className="filename">{attachment.filename}</span>
						<span className="tooltiptext">
							{attachment.filename}
						</span>
						<span className="eclip-data-elements__structured-data__attachment__action">
							{!hasExpired && HandlePreviewEyeFunction(attachment, addToastMessage)}
							{!isDeclined && isNotImported && ((eclipType === "RECEIVE" && isEditable) || (eclipType === "SEND" && (!sent || isEditable))) && (
								HandleDeleteRemoveAttachment(handleRemoveAttachment, dataElementId, type, index)
							)}
						</span>
					</div>
				))
			}
			{!isDeclined && isNotImported && ((eclipType === "RECEIVE" && isEditable) || (eclipType === "SEND" && (!sent || isEditable))) && (
				<>
					{HandleFileUploadFunction(handleFileUpload, dataElementId, type)}
					{HandleAddAttachmentFunction(handleAddAttachment, dataElementId)}
				</>
			)}
			<ConfirmDeleteModal
				isVisible={confirmModalVisible}
				title="Remove Data Element"
				text={`Are you sure want to remove ${elementName} Data Element?`}
				cancel={hideConfirmModal}
				confirm={async () => {
					hideConfirmModal();
					await addRemoveDataElements(eclipId, "REMOVE", [
						{ dataElementId, type },
					]);
					reload();
				}}
			/>
			<ConfirmDeleteModal
				isVisible={confirmClearModalVisible}
				title="Clear Imported Data"
				text={`Are you sure want to clear imported data for ${elementName} data element?`}
				cancel={hideClearConfirmModal}
				confirm={async () => {
					hideClearConfirmModal();
					handleClearImportData();
				}}
			/>
		</div>
	);
}
